import { jsx as _jsx } from "@emotion/react/jsx-runtime";
import clsx from 'clsx';
import { Text } from '@/components/ui/Typography/Body/Text';
export const RowLineTableHead = (props) => {
    const { children, className = '', width } = props;
    return (_jsx("th", Object.assign({ className: clsx(width || 'w-auto', 'px-8 first:pl-20 last:pr-20 pt-4', 'text-left', className) }, { children: _jsx(Text, Object.assign({ className: className, color: 'primary', isBold: true, size: 'sm' }, { children: children })) })));
};
